import { Flex, Icon, Text, Tooltip, Box } from '@chakra-ui/react';
import { useHistory } from 'react-router-dom';
import { useAppMode } from '@/store/app-mode';
import { Rocket02 } from '@kula-ai/icons/outline/Rocket02';
import { Home } from '@/assets/icons/nav-v2';

type ModeSwitcherProps = {
  isCollapsed: boolean;
};

const MODES = [
  {
    key: 'recruit' as const,
    label: 'Recruit',
    icon: Home,
    defaultRoute: '/dashboard',
  },
  {
    key: 'agentforge' as const,
    label: 'AgentForge',
    icon: Rocket02,
    defaultRoute: '/forge/dashboard',
  },
];

export const ModeSwitcher = ({ isCollapsed }: ModeSwitcherProps) => {
  const { mode, setMode } = useAppMode();
  const history = useHistory();

  const handleModeSwitch = (newMode: (typeof MODES)[number]) => {
    if (newMode.key === mode) return;
    setMode(newMode.key);
    history.push(newMode.defaultRoute);
  };

  return (
    <Flex direction="column" gap="2px" mb="4px">
      {MODES.map((m) => {
        const isActive = mode === m.key;
        return (
          <Tooltip
            key={m.key}
            isDisabled={!isCollapsed}
            label={m.label}
            arrowSize={8}
            hasArrow
            placement="right"
            borderRadius="4px"
            variant="default"
          >
            <Flex
              alignItems="center"
              cursor="pointer"
              p="8px 12px"
              borderRadius="6px"
              minH="42px"
              bg={isActive ? 'primary-50' : 'transparent'}
              _hover={{ bg: isActive ? 'primary-50' : '#FFF' }}
              onClick={() => handleModeSwitch(m)}
              transition="background 0.15s ease"
            >
              <Icon
                as={m.icon}
                width="18px"
                height="18px"
                color={isActive ? 'primary-700' : 'primary-900'}
                mr="10px"
              />
              {!isCollapsed && (
                <Text
                  fontSize="14px"
                  fontWeight={isActive ? 600 : 400}
                  color={isActive ? 'primary-700' : 'primary-900'}
                  whiteSpace="nowrap"
                >
                  {m.label}
                </Text>
              )}
              {isActive && !isCollapsed && (
                <Box
                  ml="auto"
                  w="6px"
                  h="6px"
                  borderRadius="full"
                  bg="primary-500"
                />
              )}
            </Flex>
          </Tooltip>
        );
      })}
    </Flex>
  );
};
